import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const LoanPurposeUpdateModalUI = ({
  context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  purpose, onPurposeChange, purposeError, setPurposeError, loanPurposeList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update purpose'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputSelectSF type='select' name='purpose'
      value={purpose} onChange={onPurposeChange} optionList={loanPurposeList}
      error={purposeError} setError={setPurposeError}
    />
  </ModalFormUI>

export default LoanPurposeUpdateModalUI
